<template>
  <div class="breadcrumb-container">
    <div
      v-for="(crumb, index) in breadCrumbs"
      :key="crumb.title"
      class="breadcrumb-item"
    >
      <p
        v-if="!crumb.hidden"
        :class="{
          'breadcrumb-item-active': crumb.active,
          'breadcrumb-item-clickable': !crumb.active && crumb.canNavigate,
          'breadcrumb-item-unclickable': !crumb.active && !crumb.canNavigate,
        }"
        @click="goToRoute(crumb.route, crumb.canNavigate)"
      >
        {{ crumb.title }}
      </p>
      <span v-if="index != breadCrumbs.length - 1 && !crumb.hidden"> / </span>
    </div>
  </div>
</template>
<script>
export default {
  name: "BreadcrumbComponent",
  props: ["breadCrumbs"],
  methods: {
    /**
     *
     * @public
     */
     goToRoute(route, canNavigate) {
      if (canNavigate) {
        this.$router.push({ name: route })
      }
    },
  },
};
</script>